import React from "react";
import { useHistory } from "react-router-dom";

import styles from "./styles.module.scss";

// assets
import topFrame from "src/assets/images/home/side_frame.svg";
import avatar from "src/assets/images/home/to_delete15.svg";
import topEdit from "src/assets/images/home/side_edit.svg";

const TopSection = ({ user }) => {
  const history = useHistory();

  return (
    <>
      {!user ? (
        <div className={styles.top_outer}>
          <img src={topFrame} alt="frame" />
          <div className={styles.top_inner}>
            <h6>Event Moon</h6>
          </div>
        </div>
      ) : (
        <>
          <div
            className={styles.top_outer}
            onClick={() => history.push("/profile")}
          >
            <img src={avatar} alt="avatar" />
            <div className={styles.top_inner}>
              <h6>{user?.userName}</h6>
              <p>
                Edit Profile <img src={topEdit} alt="edit" />
              </p>
            </div>
          </div>
          {/* <span>Lvl:1</span> */}
        </>
      )}
    </>
  );
};

export default TopSection;
